<template>
  <wz-button variant="primary" size="xl" @click="onSsoSubmit">Acceder</wz-button>
</template>

<script>
import { SecurityService } from "@/core/services";

export default {
  name: 'AccessButton',
  methods: {
    onSsoSubmit() {
      SecurityService.redirectToAuthorizeURL();
    }
  }
}
</script>
